import { render, staticRenderFns } from "./OutlookSyncSettings.vue?vue&type=template&id=537a9088&scoped=true"
import script from "./OutlookSyncSettings.vue?vue&type=script&lang=js"
export * from "./OutlookSyncSettings.vue?vue&type=script&lang=js"
import style0 from "./OutlookSyncSettings.vue?vue&type=style&index=0&id=537a9088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a9088",
  null
  
)

export default component.exports